import AdminTable from "../table";
import getHeaders from "./getReportHeaders";
import { getTableData } from "./tableData";
import Modal from "../../utils/customModal";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import React, { Fragment, useState, useEffect } from "react";
import reporticon from "../../../../static/images/Reports.svg";
import { getSessionInfo } from "../../../Redux/reducer/session";
import { loadingHtml, errorContainer } from "../../utils/functions";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import {
  getReportData,
  clearReportData,
} from "../../../Redux/actions/reportActions";
import {
  getReportData as reducerReportData,
  getReportTotalElements,
} from "../../../Redux/reducer/reports";
import useApi from "../../hooks/useApi";
import { queryString, getFilters } from "../../../components/utils/functions";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import IconShow from "canvas-core-react/lib/IconShow";
import DetailStatus from "./detailStatus";

const sizePerPage = 10;

const ReportDetails = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [menus, setMenus] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);

  const [page, setPage] = useState(0);
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });

  const { loggedUser, reportData, totalElements } = useSelector((state) => ({
    loggedUser: getSessionInfo(state),
    reportData: reducerReportData(state),
    totalElements: getReportTotalElements(state),
  }));

  const { getApiCAll, cancellCall } = useApi();
  let reportStates = "";
  switch (props.reportType) {
    case "BILLS":
      reportStates = "billStates";
      break;
    case "PROVIDERS":
      reportStates = "inviteStates";
      break;
    case "CUSTOMERS":
      reportStates = "states";
      break;
  }

  const { buttons, headers, states } = {
    buttons: t("general.buttons", { returnObjects: true }),
    headers: t("general.headers", { returnObjects: true }),
    states: t(`general.${reportStates}`, { returnObjects: true }),
  };

  useEffect(() => {
    return () => {
      dispatch(clearReportData());
      cancellCall();
    };
  }, []);

  const getData = () => {
    var data = [];

    if (reportData.length > 0) {
      data = getTableData(
        props.reportType,
        reportData,
        loggedUser.userType,
        states
      );
    }

    /* istanbul ignore else */
    if(props.reportType === "BILLS"){
          data.forEach((bill)=> {
      const BillNumber = bill.billNumber.component;
      bill.billNumber = <BillNumber {...bill.billNumber.props} />
    });
    }


    return data;
  };

  const getActions = () => {
    return (
      <div className="form-actions clearfix">
        <SecondaryButton
          id={`back-btn`}
          className="btnLimpiar"
          onClick={() => props.showDetails()}
        >
          {buttons.back}
        </SecondaryButton>
      </div>
    );
  };

  const onTableChange = ({ page }) => {
    return dispatch(
      getReportData(
        props.reportType,
        loggedUser.userType,
        page,
        sizePerPage,
        props.filters,
        props.reportType === "PROVIDERS"
      )
    ).then(() => {
      setPage(page);
    });
  };

  const generateReport = async (type, landscape = false) => {
    setModal({
      show: true,
      content: loadingHtml("Preparando reporte..."),
      onClose: closeModal,
    });

    const searchFilters = getFilters(props.filters);
    const queryFilters = [{ property: "search", value: searchFilters }];
    const query = searchFilters !== "" ? `?${queryString(queryFilters)}` : "";

    try {
      const {
        data: { data },
      } = await getApiCAll(
        `/reports/me/${props.reportType}/type/${type}/landscape/${landscape}${query}`
      );
      closeModal();
      let link = document.createElement("a");
      link.href = `data:${data.mime_type};base64,77u/${data.file_base64}`;
      link.download = `${data.filename}`;
      link.click();
    } catch (error) {
      setModal({
        show: true,
        content: errorContainer(
          "¡Error!",
          "Ocurrió un error al generar el reporte descargable. Favor intente mas tarde.",
          { continueBtn: { action: closeModal, text: "Cerrar" } }
        ),
        onClose: closeModal,
      });
    }
  };

  const closeModal = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  const handleMenu = (id) => {
    setMenus((prev) => {
      if (!prev[id]) return { ...prev, [id]: id };
      // eslint-disable-next-line no-unused-vars
      const { [id]: item, ...rest } = prev;
      return rest;
    });
  };

  const handleSelectItem = (id) => {
    setSelectedItem(id);
  };

  const getTableHeaders = () => {
    const headerAction = {
      selector: "action",
      name: `${t("clients.users.table.headers.action")}`,
      center: true,
      cellFormatter: ({ id, statusRef }) => {
        return statusRef === "PAID_REJECTED" ? (
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menus[id] || false}
            setIsMenuOpen={() => handleMenu(id)}
          >
            <ActionMenuListItem
              icon={() => <IconShow className="TextButton__icon--left" />}
              onClick={() => {
                handleMenu(id);
                setTimeout(() => {
                  handleSelectItem(id);
                }, 100);
              }}
            >
              {t("report.filters.action")}
            </ActionMenuListItem>
          </ActionMenuList>
        ) : null;
      },
    };

    const showActions =
      props.reportType === "BILLS" && loggedUser?.userType === "BSC";

    return [
      ...getHeaders(loggedUser?.userType, props.reportType, headers),
      ...(showActions ? [headerAction] : []),
    ];
  };

  if (selectedItem)
    return (
      <DetailStatus id={selectedItem} goBack={() => handleSelectItem(null)} />
    );

  return (
    <>
      <div className="header-providers">
        <div className="title">
          <img src={reporticon} className="iconList" />
          <p className="p-list">{t("report.filters.header")}</p>
        </div>
        <div className="actions flex-element left-flex report-download">
          <p>{buttons.download}</p>
          <a onClick={() => generateReport("CSV")}>Excel</a>
        </div>
      </div>
      <div className="report-detail">
        <AdminTable
          page={page}
          sizePerPage={sizePerPage}
          data={getData()}
          headers={getTableHeaders()}
          actions={getActions()}
          totalSize={totalElements}
          onTableChange={onTableChange}
        />
      </div>
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </>
  );
};

export default ReportDetails;
